
import React, { useState } from "react";
import "./RadiologyMainSection.css";
import logo from "../../Assets/logo.png";

export default function RadiologyMainSection() {
  const [id, setId] = useState("");
  const [error, setError] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const pattern = /^[A-Z0-9-]+$/; // Example -> NJ24-467

  // ✅ Validate instantly while typing
  const handleChange = (e) => {
    const value = e.target.value.toUpperCase();
    setId(value);

    setIsInvalid(false);  // no red while typing
    setError("");
  };


  // ✅ Validate & submit hidden form
  // const handleSubmit = () => {
  //   if (!pattern.test(id)) {
  //     setIsInvalid(true);
  //     setError("❌ Invalid Bill ID. Format must be like NJ24-467");
  //     return;
  //   }

  //   setIsInvalid(false);
  //   setError("");
  //   document.getElementById("hiddenSubmit").click();
  //   setId("");
  // };

  const handleSubmit = () => {
  if (!id.trim()) {
    setIsInvalid(true);
    setError("❌ Bill ID cannot be empty");
    return;
  }

  if (!pattern.test(id)) {
    setIsInvalid(true);
    setError("❌ Invalid characters in Bill ID");
    return;
  }

  setIsInvalid(false);
  setError("");
  document.getElementById("hiddenSubmit").click();
  setId("");
};


  return (
    <div className="app-container">
      {/* <div className="logo-section">
        <img src={logo} alt="RB Diagnostic Logo" className="logo-img" />
      </div> */}

      <h1 className="heading">Search Radiology Images</h1>

      <div className="input-section">
        <input
          type="text"
          placeholder="Enter Bill ID"
          value={id}
          onChange={handleChange}
          className={`input-box ${isInvalid ? "input-error" : ""}`}
        />

        {isInvalid && error && (
          <p className="error-message">{error}</p>
        )}

        {/* ✅ Hidden form */}
        <form
          action="https://pacs.rb-api.in/Launch_Viewer.asp"
          method="POST"
          style={{ display: "none" }}
        >
          <input type="hidden" name="PatientID" value={id} />
          <input type="hidden" name="Username" value="hisuser" />
          <input type="hidden" name="Password" value="hisuser" />
          <button type="submit" id="hiddenSubmit">submit</button>
        </form>

        {/* ✅ Buttons */}
        <div className="button-group">
          <button
            className="rbdButton radio-btns"
            onClick={() => {
              setId("");
              setError("");
              setIsInvalid(false);
            }}
          >
            <span className="btn-text">Reset</span>

          </button>

          <button className="rbdButton radio-btns" onClick={handleSubmit}>
            <span className="btn-text">Proceed</span>

          </button>
        </div>
      </div>
    </div>
  );
}


